import React, { useState, useEffect } from 'react'
import jsPDF from 'jspdf'
import TextareaAutosize from 'react-textarea-autosize';

import { Row, Col, Container, Card, CardBody } from 'reactstrap';
const Output = ({ data }) => {

  const [text, setText] = useState(data.TextResult)

  useEffect(()=>{
    setText(data.TextResult)
  }, [data])

  const downloadPdf = (e) => {
    e.preventDefault()
    var doc = new jsPDF()
    doc.text('Thanks for using Service', 10, 10)
    doc.text(text, 10, 20)
    doc.setFont('Calibri')
    doc.save('converted.pdf')
  }
  const downloadDoc = (e) => {
    e.preventDefault()
    var doc = new jsPDF()
    doc.text('Thanks for using Service', 10, 10)
    doc.text(text, 10, 20)
    doc.setFont('Calibri')
    doc.save('conerted.doc')
  }
  return (
    <Container className="feature30">
      <Row>
        <Col lg="12" md="12" className="text-center">
          <Card className="card-shadow data-container">
            <CardBody className="“form-group">
              <TextareaAutosize className="card-shadow form-control"
                type="text"
                value={text}
                onChange={e => setText(e.target.value)}
              />
              <div className="m-t-20">
          <button className="btn  bg-success-gradiant btn-md btn-arrow m-1" onClick={downloadPdf} type="submit"><span>Save As PDF <i className="ti-arrow-right"></i></span></button>
          <button className="btn  bg-success-gradiant btn-md btn-arrow m-1" onClick={downloadDoc} type="submit"><span>Save As Word <i className="ti-arrow-right"></i></span></button>
        </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default Output
